(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('drop-product-review-link')) {
    class DROPProductReviewLink extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.listening) return;
          this.local = this.dataset.local === 'true';
          if (!this.local) return;
          this.onClick = this.handleClick.bind(this);
          this.addEventListener('click', this.onClick);
          this.listening = true;
          if (!this.syncTarget()) this.watchForTarget();
        });
      }

      disconnectedCallback() {
        if (this.onClick) this.removeEventListener('click', this.onClick);
        this.listening = false;
        this.observer?.disconnect();
        this.observer = null;
      }

      getTarget() {
        return Array.from(document.querySelectorAll('#judgeme_product_reviews')).find((target) => {
          const id = target.dataset.productId || target.dataset.id;
          return !target.hidden && (!id || id === this.dataset.productId);
        });
      }

      setLink(href) {
        const rating = this.querySelector('.star-rating-container');
        if (!rating) return;
        const tag = href ? 'A' : 'DIV';
        if (rating.tagName === tag) {
          if (href) rating.setAttribute('href', href);
          return;
        }
        const replacement = document.createElement(href ? 'a' : 'div');
        replacement.className = rating.className;
        if (href) replacement.setAttribute('href', href);
        replacement.append(...Array.from(rating.childNodes));
        rating.replaceWith(replacement);
      }

      syncTarget() {
        const target = this.getTarget();
        this.setLink(target ? '#judgeme_product_reviews' : null);
        if (target) {
          this.observer?.disconnect();
          this.observer = null;
        }
        return target;
      }

      watchForTarget() {
        if (this.observer || typeof MutationObserver === 'undefined' || !document.body) return;
        this.observer = new MutationObserver(() => {
          if (this.isConnected) this.syncTarget();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
      }

      handleClick(event) {
        const link = event.target.closest?.('a.star-rating-container');
        if (!link || !this.contains(link)) return;
        const target = this.getTarget();
        if (!target) {
          event.preventDefault();
          this.syncTarget();
          this.watchForTarget();
          return;
        }
        if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'instant' : 'smooth' });
        if (event.detail === 0) {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
      }
    }
    customElements.define('drop-product-review-link', DROPProductReviewLink);
  }
  } catch(e) { console.error(e); }
})();

})();
